import React from 'react';
import {
  Route, Redirect, Switch,
} from 'react-router-dom';
import AccountIndex from '../../pages/account';
import PartialPrepay from '../../pages/account/partial-prepay';
import TotalPrepay from '../../pages/account/total-prepay';
import FullPrepayOverview from '../../pages/account/total-prepay/overview';
import AccountBnplView from '../../pages/account/bnpl';
import ProtectedRoute from '../../components/ProtectedRoute';
import RefinanceView from '../../pages/account/refinance';
import InvestmentView from '../../pages/account/investment';
import PacView from '../../pages/account/pac';
import AccountNavbar from '../../components/AccountNavbar';
import AuthorizationView from '../../pages/authorization';
import { EligibilityProvider } from '../../context/EligibilityContext';
import { getElementFromStorage } from '../../utils/helpers';

export default function AccountProtectedRoutes() {
  const token = getElementFromStorage('token');
  return (
    <EligibilityProvider token={token}>
      <AccountNavbar>
        <Route
          render={
          ({ location }) => (
            <Switch location={location}>
              <ProtectedRoute exact path="/account" component={AccountIndex} />
              <ProtectedRoute exact={false} path="/account/partial-prepay/:loanId" component={PartialPrepay} />
              <ProtectedRoute exact path="/account/total-prepay/:loanId" component={TotalPrepay} />
              <ProtectedRoute exact path="/account/total-prepay/overview/:loanId" component={FullPrepayOverview} />
              <ProtectedRoute exact path="/account/bnpl" component={AccountBnplView} />
              <ProtectedRoute exact path="/account/pac" component={PacView} />
              <ProtectedRoute exact path="/account/investment" component={InvestmentView} />
              <ProtectedRoute exact={false} path="/account/refinance/:loanId/cashout" component={RefinanceView} />
              <ProtectedRoute exact={false} path="/account/refinance/:loanId/rate-period/" component={RefinanceView} />
              <ProtectedRoute exact path="/account/authorization" component={AuthorizationView} />
              <Route path="/">
                <Redirect to="/account" />
              </Route>
            </Switch>
          )
        }
        />
      </AccountNavbar>
    </EligibilityProvider>
  );
}
